import { ActionEventAction, ElementEventAction, EventTriggerFixed } from '@user-portal/wikr-analytics';

import { trackClick, trackEventFixed } from './mainTrackers';

export const sendAnalyticDeeplinkLoadClick = () => {
    trackEventFixed({ event: EventTriggerFixed.deeplinkLoad });
};

export const sendAnalyticDownloadAppClick = (eventLabel: string) => {
    trackClick({ elementEvent: ElementEventAction.button, actionEvent: ActionEventAction.downloadApp, eventLabel });
};
